// hooks/useChangePassword.js
import { message } from 'antd';
import { useAxiosPrivate } from './useAxiosPrivate'; // Adjust the import path as needed
import OkModal from "../components/OkModal.js";

const useChangePassword = () => {
    const axiosPrivate = useAxiosPrivate();
    const baseURL = process.env.REACT_APP_API_BASE_URL;

    //console.log("hook useChangePassword");

    const changePassword = async (username, values) => {
        try {
            const response = await axiosPrivate.post(`${baseURL}/utilizadores_change_password/`, {
                utilizador: username,
                currentPassword: values.currentPassword,
                newPassword: values.newPassword,
            });

            // Check the response for login status
            if (response.data.loginStatus) {
                message.success('Password changed successfully');
                return { success: true, message: 'Password changed successfully' };
            } else {
                //alert(response.data.message);
                return { success: false, message: response.data.message };
            }
        } catch (error) {
            // Show an error message if the request fails
            message.error('Failed to change password');
            return { success: false, message: 'Failed to change password' };
        }
    };

    // Return an object containing the changePassword function
    return { changePassword };
};

export default useChangePassword;
